import classNames from 'classnames';
import React from 'react';

import { memoizedComponent } from 'utils/memoizeComponent';

import './index.css';

export const InfoIcon: React.FC<
  React.PropsWithChildren<{
    className?: string;
    style?: React.CSSProperties;
    large?: boolean;
    type?:
      | 'primary'
      | 'secondary'
      | 'header'
      | 'header-light'
      | 'coin'
      | 'notification'
      | 'notification-pressed'
      | 'white'
      | 'message';
    onClick?: () => void;
  }>
> = memoizedComponent(({ className = '', style, large, type = 'primary', onClick = () => null }) => {
  const iconClassNames = classNames({
    'icon-inform': true,
    'icon-inform--large': large,
    [`icon-inform--${type}`]: type,
    [`${className}`]: className,
  });

  return (
    <span className={iconClassNames} onClick={onClick}>
      <svg
        className='icon-inform-svg'
        style={style}
        width='16'
        height='16'
        viewBox='0 0 16 16'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='8' cy='8' r='8' />
        <path d='M8.80078 6.3999V11.9999' strokeWidth='1.2' strokeLinecap='round' />
        <path d='M8.80078 6.3999L6.40078 6.3999' strokeWidth='1.2' strokeLinecap='round' />
        <path d='M10.4004 12L6.40039 12' strokeWidth='1.2' strokeLinecap='round' />
        <circle cx='8.80065' cy='3.99987' r='0.558851' strokeWidth='0.8' />
        <defs>
          <clipPath id='clip0_2333_138060'>
            <rect width='16' height='16' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
});
